import React from 'react';
import {
  BoxCubeIcon,
  UserCircleIcon,
  PlugInIcon,
  GridIcon,
  WheelIcon,
  ScubaDivingTankIcon,
  UserIcon,
  BellIcon,
  SettingsIcon,
  ShipIcon,
  ReportIcon,
} from '@/assets/icons'; // adjust the path accordingly
import { Ratio } from 'lucide-react';

export type NavItem = {
  name: string;
  icon: React.ReactNode;
  path?: string;
  subItems?: { name: string; path: string; pro?: boolean; new?: boolean }[];
};

export type NavItemGroup = {
  section: string;
  items: NavItem[];
};

export const navItemGroups: NavItemGroup[] = [
  {
    section: 'Main',
    items: [
      {
        name: 'Applications',
        icon: <ShipIcon />,
        path: '/apps',
      },
      {
        name: 'Dashboard',
        icon: <Ratio className="h-5 w-5" />,
        path: '/dashboard',
      },
    ],
  },
  {
    section: 'Management',
    items: [
      {
        name: 'Dashboard',
        icon: <Ratio className="h-5 w-5" />,
        path: '/dashboard',
      },
      {
        name: 'Report',
        icon: <ReportIcon />,
        path: '/dashboard/report/history',
      },
      {
        name: 'Vessels',
        icon: <WheelIcon />,
        path: '/dashboard/vessels',
      },
      {
        name: 'Fleets',
        icon: <ScubaDivingTankIcon />,
        path: '/dashboard/fleets',
      },
    ],
  },
  {
    section: 'Others',
    items: [
      {
        name: 'Notification',
        icon: <BellIcon />,
        path: '/dashboard/notifications/history',
      },
    ],
  },
];
